// Scroll page to back-to-top
const backToTop = document.querySelector('.js-back-to-top')
const scrollAmount = 200

// Show back-to-top button if scrollAmount is reached
window.addEventListener('scroll', _ => {
  if (window.pageYOffset > scrollAmount) {
    backToTop.classList.add('visible')
  } else {
    backToTop.classList.remove('visible')
  }
})

// Scroll to top yay!
// Needs smooth scroll behavior polyfill for Safari
backToTop.addEventListener('click', e => {
  e.preventDefault()
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })
})
